import { defineMessage } from 'react-intl';

/** Messages for the admin alerts manage screen. */
export const manageAlertsMessages = {
  waGroupTitle: defineMessage({
    id: 'admin.alertsScreen.waGroup.title',
    defaultMessage: 'Grupo de WhatsApp para alertas',
  }),
  getInviteLink: defineMessage({
    id: 'admin.dashboard.btnLink',
    defaultMessage: 'Obtener enlace de invitación del grupo',
  }),
  copyInviteLink: defineMessage({
    id: 'admin.dashboard.copyLink',
    defaultMessage: 'Copiar URL del enlace',
  }),
};
